export default __webpack_public_path__ + "static/1065-08114028259db1696a02536efb8da635.gif";